// src/Layout.jsx
import React, { useState } from "react";
import Sidebar from "./components/Sidebar";
import Leaderboard from "./components/Leaderboard";
import Header from "./components/Header";
import { Outlet } from "react-router-dom";

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [leaderboardOpen, setLeaderboardOpen] = useState(false);

  // GLOBAL PROFILE PIC
  const [userAvatar, setUserAvatar] = useState("/user.svg");

  return (
    <>
      {/* HEADER */}
      <Header
        onMenuOpen={() => setSidebarOpen(true)}
        userAvatar={userAvatar}
      />

      {/* FULL SIDEBAR */}
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onLeaderboardToggle={() => setLeaderboardOpen(true)}
      />

      {/* LEADERBOARD PANEL */}
      <Leaderboard
        open={leaderboardOpen}
        onClose={() => setLeaderboardOpen(false)}
      />

      {/* PAGES */}
      <main className="dash-body">
        <div className="dash-inner">
          <Outlet context={{ userAvatar, setUserAvatar }} />
        </div>
      </main>
    </>
  );
}
